module.exports = __webpack_public_path__ + "static/media/un.18c782f8.svg";